<script lang="ts">
      let { node, children = undefined } = $props()

      const { format } = $state(node)
</script>

<br />
